export function accountMenuToggle(this: HTMLElement, e: Event): void {
    e.stopPropagation();
    document.getElementById('account-menu').classList.toggle('admin-header_dropdown_list--open');
}

export function clearAdminDropDowns(): void {
    clearAdminDropDown('account-menu');
    clearAdminDropDown('company-selection');
    clearAdminDropDown('location-selection');
}

function clearAdminDropDown(id: string) {
    const dropDown = document.getElementById(id);
    if (dropDown) {
        dropDown.classList.remove('admin-header_dropdown_list--open');
    }
}

export function showCompanySelector(this: HTMLElement, e: Event): void {
    e.stopPropagation();

    clearAdminDropDown('location-selection');

    document.getElementById('company-selection').classList.toggle('admin-header_dropdown_list--open');
}

export function companySelectionLinkClicked(this: HTMLElement, e: Event): void {
    e.stopPropagation();

    fetch(siteRoot + 'Account/SwitchCompany', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ companyId: this.dataset.companyid })
    }).then(() => location.reload());
}

export function showLocationSelector(this: HTMLElement, e: Event): void {
    e.stopPropagation();

    clearAdminDropDown('company-selection');

    document.getElementById('location-selection').classList.toggle('admin-header_dropdown_list--open');
}

export function locationSelectionLinkClicked(this: HTMLElement, e: Event): void {
    e.stopPropagation();

    fetch(siteRoot + 'Account/SwitchLocation', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ locationId: this.dataset.locationid })
    }).then(() => location.reload());
}
